var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6701 18.67L20.8901 17.56V14.78M14.2201 9.78L12.0001 10.89L14.2201 9.78ZM12.0001 10.89L9.78011 9.78L12.0001 10.89ZM12.0001 10.89V13.67V10.89ZM20.8901 6.44L18.6701 7.55L20.8901 6.44ZM20.8901 6.44L18.6701 5.33L20.8901 6.44ZM20.8901 6.44V9.22V6.44ZM14.2201 3.11L12.0001 2L9.78011 3.11H14.2201ZM3.11011 6.44L5.33011 5.33L3.11011 6.44ZM3.11011 6.44L5.33011 7.55L3.11011 6.44ZM3.11011 6.44V9.22V6.44ZM12.0001 22L9.78011 20.89L12.0001 22ZM12.0001 22L14.2201 20.89L12.0001 22ZM12.0001 22V19.22V22ZM5.33011 18.67L3.11011 17.56V14.78L5.33011 18.67Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox3);
export default ForwardRef;